import styled from "@emotion/styled";
import { Avatar, Link, ScreenReaderText, Text } from "atoms";
import { Image } from "features/images";

type OpenCallPartnerChipProps = {
  partnerName: string;
  partnerLogo?: Image;
  link?: string;
  hasBg?: boolean;
};

function OpenCallPartnerChip({
  partnerName,
  partnerLogo,
  link,
  hasBg = true,
  ...props
}: OpenCallPartnerChipProps) {
  if (!partnerName) {
    return null;
  }

  return (
    <Chip hasBg={hasBg} hasPartnerLogo={!!partnerLogo?.url} {...props}>
      {partnerLogo?.url && (
        <Avatar src={partnerLogo.url150 ?? partnerLogo.url} />
      )}
      <SText>
        <ScreenReaderText as="span">In partnership with</ScreenReaderText>
        {link ? <Link to={link}>{partnerName}</Link> : partnerName}
      </SText>
    </Chip>
  );
}

const Chip = styled.div<{ hasBg?: boolean; hasPartnerLogo?: boolean }>(
  ({ hasBg, hasPartnerLogo, theme }) => ({
    alignItems: "center",
    backgroundColor: hasBg ? theme.colors.bg : theme.colors.transparent,
    borderRadius: hasBg ? theme.borderRadius.round : 0,
    boxShadow: hasBg ? theme.boxShadow.light : "none",
    display: "inline-flex",
    flexWrap: "nowrap",
    fontSize: hasBg ? 13.5 : 15,
    gap: 6,
    position: "relative",
    overflow: "hidden",
    maxWidth: hasBg ? "calc(100% - 20px)" : "none",
    whiteSpace: hasBg ? "nowrap" : "normal",
    padding: hasBg ? "4px 1em 4px 4px" : 0,
    ...(!hasPartnerLogo && hasBg && { paddingLeft: "1em" }),
    p: {
      textOverflow: "ellipsis",
      overflow: "hidden",
      lineHeight: "1.2",
    },
    img: {
      width: hasBg ? 25 : 30,
      height: hasBg ? 25 : 30,
      maxWidth: hasBg ? 25 : 30,
      maxHeight: hasBg ? 25 : 30,
      flex: hasBg ? "0 0 25px" : "0 0 30px",
      margin: 0,
    },
    "&&, && a": { color: hasBg ? theme.colors.fg : "inherit" },
    "a:after": {
      content: "''",
      position: "absolute",
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      zIndex: 2,
    },
  }),
);

const SText = styled(Text)(() => ({
  margin: 0,
  fontWeight: "bold",
}));
export { OpenCallPartnerChip };
